exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".nil-sa-elements-timeslot-style__timeSlot{cursor:pointer;padding:8px;margin:0 auto;margin-bottom:10px;background:#fff;border-radius:3px}.nil-sa-elements-timeslot-style__selected{font-weight:600;color:#e6f2fb;background-color:#2b4d66!important;border-right:1px solid #223c4f!important;border-bottom:1px solid #223c4f!important}", ""]);

// exports
exports.locals = {
	"timeSlot": "nil-sa-elements-timeslot-style__timeSlot",
	"selected": "nil-sa-elements-timeslot-style__selected"
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader??ref--2-2!../node_modules/postcss-loader/lib??ref--2-3!../node_modules/less-loader/dist/cjs.js??ref--2-4!./components/elements/TimeSlot/style.less
// module id = 383
// module chunks = 0